import React from 'react';
import Content_mobilePicture from './content/Content_mobilePicture'; // 手机图片元素
import Content_1 from './content/Content_1'; // RSS阅读器
import Content_7 from './content/Content_7'; // 文档中心
import Content_8 from './content/Content_8'; // 流程中心
import Content_11 from './content/Content_11'; // 最新客户
import Content_12 from './content/Content_12'; // 最新会议
import Content_6 from './content/Content_6'; // 未读文档
//import Content_13 from './content/Content_13'; // 未读协作
import Content_13_new from './content/Content_13_new'; // 未读协作
import Content_14 from './content/Content_14'; // 当月目标
import Content_15 from './content/Content_15'; // 当日计划
import Content_16 from './content/Content_16'; // 我的邮件
import Content_9 from './content/Content_9'; // 消息提醒
//import Content_10 from './content/Content_10'; // 我的项目
import Content_10_new from './content/Content_10_new'; // 我的项目
import Content_17 from './content/Content_17'; // 多新闻中心
import Content_18 from './content/Content_18'; // 期刊中心
import Content_19 from './content/Content_19'; // 股票元素
import Content_25 from './content/Content_25'; // 文档内容
import Content_29 from './content/Content_29'; // 自定义页面
import Content_32 from './content/Content_32'; // 计划任务
import Content_Task from './content/Content_Task'; // 任务元素
import Content_34 from './content/Content_34'; // 知识订阅
import Content_audio from './content/Content_audio'; // 音频元素
import Content_blogStatus from './content/Content_blogStatus'; // 微博动态
import Content_favourite from './content/Content_favourite'; // 收藏元素
import Content_Flash from './content/Content_Flash'; // Flash元素
import Content_menu from './content/Content_menu'; // 自定义菜单
import Content_notice from './content/Content_notice'; // 公告栏元素
import Content_picture from './content/Content_picture'; // 图片元素
import Content_reportForm from './content/Content_reportForm'; // 图表元素
import Content_searchengine from './content/Content_searchengine'; // 搜索元素
import Content_Slide from './content/Content_Slide'; // 幻灯片
import Content_video from './content/Content_video'; // 视频元素
import Content_weather from './content/Content_weather'; // 天气元素
import Content_scratchpad from './content/Content_scratchpad'; // 便签元素
import Content_MyCalendar from './content/Content_MyCalendar'; // 日历日程
import Content_DataCenter from './content/Content_DataCenter'; // 个人数据
import Content_plan from './content/Content_plan'; // 计划报告元素
import Content_jobsinfo from './content/Content_jobsinfo'; // 多岗位办理事项
import Content_outterSys from './content/Content_outterSys'; // 集成登录
import Content_contacts from './content/Content_contacts'; // 通讯录
import Content_addwf from './content/Content_addwf'; // 新建流程
import Content_imgSlide from './content/Content_imgSlide'; // 多图元素
import Content_newNotice from './content/Content_newNotice'; // 公告元素
import Content_OutData from './content/Content_OutData'; // 外部数据元素
import Content_FormModeCustomSearch from './content/Content_FormModeCustomSearch'; // 建模查询中心
import Content_MeetingCalendar from './content/Content_MeetingCalendar'; // 会议日历元素
import Content_CalendarEle from './content/Content_CalendarEle'; // 会议元素
import Content_bookshelf from './content/Content_bookshelf'; // 书柜元素
import Content_newMobilePicture from './content/Content_newMobilePicture'; // 移动图片
import Content_fnaBudgetAssistant from './content/Content_fnaBudgetAssistant'; // 费用报销智能助手
import Content_fnaBudgetAssistant1 from './content/Content_fnaBudgetAssistant1'; // 审批助手元素
import Content_CoreMail from './content/Content_CoreMail'; // CoreMail邮箱
import Content_news from './content/Content_news'; // 公司新闻
import Content_ProcessTask from './content/Content_ProcessTask';
import Content_login from "./content/Content_login"; // 登录系统元素
import Content_CustomElement from "./content/Content_CustomElement"; // 自定义元素
import Content_dy from "./content/Content_dy";//

class Tab4Content extends React.Component {
    render() {
        const {hpid, eid, ebaseid, eShareLevel, eContent, synergyParams,dyParams,sebaseid}=this.props;
        const props = {hpid, eid, ebaseid, eShareLevel,dyParams,sebaseid, ...eContent};
        if (/_DY$/.test(ebaseid)) {
            return <Content_dy ref={ebaseid} {...props} />
        }
        if (/^Custom_/.test(ebaseid)) {
            return <Content_CustomElement ref={ebaseid} {...props} synergyParams={synergyParams}/>
        }

        let tab4Content=<div></div>;
        switch (ebaseid) {
            // 手机图片元素
            case 'mobilePicture':tab4Content=<Content_mobilePicture ref={ebaseid} {...props}/>;break;
            // RSS阅读器
            case '1':tab4Content=<Content_1 ref={ebaseid} {...props}/>;break;
            // 文档中心
            case '7':tab4Content=<Content_7 ref={ebaseid} {...props} synergyParams={synergyParams}/>;break;
            // 流程中心
            case '8':tab4Content=<Content_8 ref={ebaseid} {...props} synergyParams={synergyParams}/>;break;
            // 最新客户
            case '11':tab4Content=<Content_11 ref={ebaseid} {...props}/>;break;
            // 最新会议
            case '12':tab4Content=<Content_12 ref={ebaseid} {...props}/>;break;
            // 未读文档
            case '6':tab4Content=<Content_6 ref={ebaseid} {...props}/>;break;
            // 未读协作
            //case '13':tab4Content=<Content_13 ref={ebaseid} {...props}/>;break;
            case '13':tab4Content=<Content_13_new ref={ebaseid} {...props}/>;break;
            // 当月目标
            case '14':tab4Content=<Content_14 ref={ebaseid} {...props}/>;break;
            // 当日计划
            case '15':tab4Content=<Content_15 ref={ebaseid} {...props}/>;break;
            // 我的邮件
            case '16':tab4Content=<Content_16 ref={ebaseid} {...props}/>;break;
            // 消息提醒
            case '9':tab4Content=<Content_9 ref={ebaseid} {...props}/>;break;
            // 我的项目
            //case '10':tab4Content=<Content_10 ref={ebaseid} {...props}/>;break;
            case '10':tab4Content=<Content_10_new ref={ebaseid} {...props}/>;break;
            // 多新闻中心
            case '17':tab4Content=<Content_17 ref={ebaseid} {...props}/>;break;
            // 期刊中心
            case '18':tab4Content=<Content_18 ref={ebaseid} {...props}/>;break;
            // 股票元素
            case '19':tab4Content=<Content_19 ref={ebaseid} {...props}/>;break;
            // 文档内容
            case '25':tab4Content=<Content_25 ref={ebaseid} {...props}/>;break;
            // 自定义页面
            case '29':tab4Content=<Content_29 ref={ebaseid} {...props}/>;break;
            // 计划任务
            case '32':tab4Content=<Content_32 ref={ebaseid} {...props}/>;break;
            // 任务元素
            case 'Task':tab4Content=<Content_Task ref={ebaseid} {...props}/>;break;
            // 知识订阅
            case '34':tab4Content=<Content_34 ref={ebaseid} {...props}/>;break;
            // 音频元素
            case 'audio':tab4Content=<Content_audio ref={ebaseid} {...props}/>;break;
            // 微博动态
            case 'blogStatus':tab4Content=<Content_blogStatus ref={ebaseid} {...props}/>;break;
            // 收藏元素
            case 'favourite':tab4Content=<Content_favourite ref={ebaseid} {...props}/>;break;
            // Flash元素
            case 'Flash':tab4Content=<Content_Flash ref={ebaseid} {...props}/>;break;
            // 自定义菜单
            case 'menu':tab4Content=<Content_menu ref={ebaseid} {...props}/>;break;
            // 公告栏元素
            case 'notice':tab4Content=<Content_notice ref={ebaseid} {...props}/>;break;
            // 图片元素
            case 'picture':tab4Content=<Content_picture ref={ebaseid} {...props}/>;break;
            // 图表元素
            case 'reportForm':tab4Content=<Content_reportForm ref={ebaseid} {...props} synergyParams={synergyParams}/>;break;
            // 搜索元素
            case 'searchengine':tab4Content=<Content_searchengine ref={ebaseid} {...props}/>;break;
            // 幻灯片
            case 'Slide':tab4Content=<Content_Slide ref={ebaseid} {...props}/>;break;
            // 视频元素
            case 'video':tab4Content=<Content_video ref={ebaseid} {...props}/>;break;
            // 天气元素
            case 'weather':tab4Content=<Content_weather ref={ebaseid} {...props}/>;break;
            // 便签元素
            case 'scratchpad':tab4Content=<Content_scratchpad ref={ebaseid} {...props}/>;break;
            // 日历日程
            case 'MyCalendar':tab4Content=<Content_MyCalendar ref={ebaseid} {...props} synergyParams={synergyParams}/>;break;
            // 个人数据
            case 'DataCenter':tab4Content=<Content_DataCenter ref={ebaseid} {...props}/>;break;
            // 计划报告元素
            case 'plan':tab4Content=<Content_plan ref={ebaseid} {...props}/>;break;
            // 多岗位办理事项
            case 'jobsinfo':tab4Content=<Content_jobsinfo ref={ebaseid} {...props}/>;break;
            // 集成登录
            case 'outterSys':tab4Content=<Content_outterSys ref={ebaseid} {...props}/>;break;
            // 通讯录
            case 'contacts':tab4Content=<Content_contacts ref={ebaseid} {...props}/>;break;
            // 新建流程
            case 'addwf':tab4Content=<Content_addwf ref={ebaseid} {...props}/>;break;
            // 多图元素
            case 'imgSlide':tab4Content=<Content_imgSlide ref={ebaseid} {...props}/>;break;
            // 公告元素
            case 'newNotice':tab4Content=<Content_newNotice ref={ebaseid} {...props}/>;break;
            // 外部数据元素
            case 'OutData':tab4Content=<Content_OutData ref={ebaseid} {...props}/>;break;
            // 建模查询中心
            case 'FormModeCustomSearch':tab4Content=<Content_FormModeCustomSearch ref={ebaseid} {...props}/>;break;
            // 会议日历元素
            case 'MeetingCalendar':tab4Content=<Content_MeetingCalendar ref={ebaseid} {...props}/>;break;
            // 会议元素
            case 'CalendarEle':tab4Content=<Content_CalendarEle ref={ebaseid} {...props}/>;break;
            // 书柜元素
            case 'bookshelf':tab4Content=<Content_bookshelf ref={ebaseid} {...props}/>;break;
            // 移动门户图片
            case 'newMobilePicture':tab4Content=<Content_newMobilePicture ref={ebaseid} {...props}/>;break;
             // 移动门户图片
            case 'fnaBudgetAssistant':tab4Content=<Content_fnaBudgetAssistant ref={ebaseid} {...props}/>;break;
             // 移动门户图片
            case 'fnaBudgetAssistant1':tab4Content=<Content_fnaBudgetAssistant1 ref={ebaseid} {...props}/>;break;
            // CoreMail邮箱
            case 'CoreMail':tab4Content=<Content_CoreMail ref={ebaseid} {...props}/>;break;
            // CoreMail邮箱
            case 'news':tab4Content=<Content_news ref={ebaseid} {...props}/>;break;
            //登录系统元素
            case 'login':tab4Content=<Content_login ref={ebaseid} {...props}/>;break;
            // 我的任务元素
            case 'processTask':tab4Content=<Content_ProcessTask ref={ebaseid} {...props}/>;break;
            // 默认
            default:tab4Content=<div></div>;
        }
        return tab4Content;
    }

    getSaveValues(ebaseid) {
        return this.refs[ebaseid].getSaveValues();
    }
}

export default Tab4Content;



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal/elements/components/common/setting_new/Tab4Content.js